import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-select-question',
  templateUrl: 'select-question.html',
})
export class SelectQuestionPage {
  cards: any;
  category: any;
  dataProvider: any;
  onGoingRequest: boolean;
  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.cards = navParams.get('cards');
    this.category = navParams.get('category');
    this.dataProvider = navParams.get('dataProvider');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SelectQuestionPage');
    this.onGoingRequest = false;
  }

  questionSelected(title) {
    if (!this.onGoingRequest) {
      this.onGoingRequest = true;
      this.dataProvider.selectQuestionCard(title, this.category);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/select-question/select-question.ts